import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {reduxForm, getFormValues, Field} from 'redux-form';
// import {HttpStatusCode} from 'axios';
import Modal from '@mui/material/Modal';
import Grid from '@mui/material/Grid';
import withStyles from '@mui/styles/withStyles';
// import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import SearchIcon from '@mui/icons-material/Search';
import {InputAdornment} from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';

import withRouter from '../../../organisms/withRouter.js';
import withFormatMessage from '../../../organisms/withFormatMessage.js';
import {withMediaQuery} from '../../../atoms/withMediaQuery.js';
import PaperPart from '../../../atoms/PaperPart.js';
// import {postRequest} from '../../../../common/backend.js';
import {commonOperations} from '../../../../reducks/common/index.js';
import PageTitle from '../../../molecules/PageTitle.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
// import {requiredCheck, lengthCheck} from '../../../../common/inputCheck.js';
import SaveIcon from '@mui/icons-material/Save';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import {renderTextField,
  renderSelect,
  renderCheckbox,
  renderRadioGroup,
} from '../../../atoms/CustomPart.js';
import * as validateRule from '../../../validateRule.js';
import {Typography,
  // FormControl, FormGroup,
  // FormLabel,
  FormControlLabel,
  Radio,
} from '@mui/material';

import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
// import {createFieldItems,
// createGridFields,
// } from '../../../../common/commonGmn.js';
// import {GMN} from '../../../../common/commonConst.js';
import CustomFlexGrid, {createComponents} from '../../../molecules/CustomFlexGrid.js';
// import {createDataMap} from '../../../../common/commonGmn.js';
import CommonTheme from '../../../../Theme.js';

const styles = (theme) => ({
  modal: {
    alignItems: 'center',
    justifyContent: 'center',
    overflowY: 'none',
  },
  paper: {
    backgroundColor: '#fafafa',
    border: '3px solid #fafafa',
    width: 'auto',
    maxWidth: '40%',
    minWidth: '25%',
    height: 'auto',
    idth: '95%',
    overflow: 'auto',
    padding: '16pt',
    fontSize: '10pt',
    position: 'absolute',
    top: '45%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  button: {
    margin: '15px 10px 5px 10px',
  },
  table: {
    border: '0.5px solid gray',
    width: '100%',
  },
  tableHeader: {
    color: CommonTheme.palette.primary.contrastText,
    backgroundColor: CommonTheme.chubuPalette.primary.dark,
    borderRight: '1px solid gray',
    borderBottom: '1px solid gray',
    textAlign: 'center',
  },
  tableData: {
    whiteSpace: 'pre-wrap',
    borderRight: '1px solid gray',
    borderBottom: '1px solid gray',
  },
  fields: {
    margin: '-10px -10px -10px -10px',
  },
});

// const gridItems = {
//   OrderNo: {binding: 'orderNo', header: ' ', dataType: 'Number', maxLength: 2, width: 50, required: true},
//   ZetuenTeikoti: {binding: 'zetuenTeikoti', header: '絶縁抵抗値[MΩ]', dataType: 'Number', maxLength: 3, width: 150, required: true},
//   IoVal: {binding: 'ioVal', header: 'I0(I0r)[mA]', dataType: 'Number', maxLength: 3, width: 150, isReadOnly: true, required: true},
//   FutekigoRiyu: {binding: 'futekigoRiyu', header: '不適合理由', dataType: 'String', dataMap: null, width: 200, required: true},
// };


// const listData = [
//   {orderNo: 1, zetuenTeikoti: 10, ioVal: 20, futekigoRiyu: '1'},
// ];

/**
 * 調査入力情報ダイアログ
 *
 * 遷移元指定パラメータ
 *
 */
class TsInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDisabled: true,
      isYknDisabled: false,
      warningMessages: null,
      tsInfo: {},
      keikiRadioVal: '1',
    };

    // this.gridRefBunki = React.createRef();
    // this._gridItems = [];
    // this.setGridItems();
  }

  async componentDidMount() {
    this.props.reset();
    this.getInitializeData();
  }

  // /**
  //  * 更新処理
  //  * @param {*} prevProps 前のprops
  //  */
  // componentDidUpdate() {
  //   if (this.gridRefBunki && this.gridRefBunki.current) {
  //     this.gridRefBunki.current.setItemsSource(listData);
  //   }
  // }

  /**
   * 初期データ検索
   */
  getInitializeData = async () => {
    let _isDisabled = false;
    // 仮データ
    let _tsInfo = {...this.state.tsInfo};

    _tsInfo = {
      keikiNo1: '1234567890',
      keikiNo2: '1234567891',
      keikiNo3: '1234567892',
      keikiNo4: '1234567893',
    };

    if (this.props.tsKasyo === '調査完了') {
      _tsInfo = {
        homonDate: '2025-01-12',
        homonStatus: '1',
        keikiNo1: '1234567890',
        keikiNo2: '1234567891',
        keikiNo3: '1234567892',
        keikiNo4: '1234567893',
        keikiNasi1: true,
        skuteiFuno2: true,
        zetuenTeikoti1: 44444,
        zetuenTeikoti2: 55555,
        zetuenTeikoti3: 66666,
        zetuenTeikoti4: 77777,
        ioIor1: 10.12,
        ioIor2: 11.12,
        ioIor3: 12.12,
        ioIor4: 13.12,
        io1: 20.23,
        io2: 21.23,
        io3: 22.23,
        io4: 23.23,
        sijisu1: 111,
        sijisu2: 222,
        sijisu3: 333,
        sijisu4: 444,
        sujisuKakuninFunou3: true,
        okugaiTsResult: '1',
        okunaiTsResult: '2',
        hasSwitch: '1',
        jisiZumi: true,
        tsMemo: 'テストメモ１２３',
        beforeHenkoTsGyosyu: '02',
        afterHenkoTsGyosyu: '03',
        beforeHenkoTsKanriKbn: '0',
        afterHenkoTsKanriKbn: '3',
        tsGyosyuMemo: '備考あああ',
        yokunendoTsRiyu: '12',
        yokunendoTsRiyuMemo: '備考えええ',
      };
    }

    this.props.doSetInitValues(_tsInfo);

    // if (this.gridRefBunki && this.gridRefBunki.current) {
    //   this.gridRefBunki.current.setItemsSource(listData);
    // }

    this.setState({
      tsInfo: _tsInfo,
      isDisabled: _isDisabled,
      isKeikiShow: (_tsInfo.homonStatus === '1' || _tsInfo.homonStatus === '2'),
      isOkugaiTsShow: _tsInfo.homonStatus !== '3',
      isOkunaiTsShow: _tsInfo.homonStatus === '1',
    });
  };

  // /**
  //  * 画面項目設定
  //  */
  // setGridItems = () => {
  //   for (const key of Object.keys(gridItems)) {
  //     this._gridItems[key] = {...gridItems[key]};
  //     if (Object.hasOwn(this._gridItems[key], 'dataMap')) {
  //       let map = this.getDataMap(this._gridItems[key]);
  //       this._gridItems[key].dataMap = map;
  //     }
  //   }
  // };

  // /**
  //  * 画面項目に合うデータマップを取得
  //  * @param {object} item 対象
  //  * @return {object} データマップ
  //  */
  // getDataMap(item) {
  //   const key = Object.hasOwn(item, 'dataMapKey') ?
  //       item.dataMapKey : item.binding;
  //   return createDataMap(this.props.genericMap, key);
  // }

  /**
   * 区分リストを取得
   * @param {*} kbnMap リスト
   * @return {kbnList} 区分リスト
   */
  getKbnList(kbnMap) {
    const list = [];
    const selections = kbnMap;
    list.push(<MenuItem value="">&nbsp;</MenuItem>);
    if (kbnMap != null) {
      for (const selection of selections) {
        list.push(<MenuItem value={selection.cd}>
          {selection.name}</MenuItem>);
      }
    }
    return list;
  }

  /**
   * ラジオボタン内容を設定する。
   * @param {*} items
   * @param {string} key ラジオボタンキー
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  getRadioItems = (items, key) => {
    let retItems = [];
    if (items != null && items.length > 0) {
      items.forEach((item) => {
        let radioKey = key + item.cd;
        retItems.push(
            <FormControlLabel
              key={radioKey}
              value={item.cd}
              control={<Radio />}
              label={item.cdName}
            />,
        );
      });
    }
    return retItems;
  };

  /**
   * 一時保存
   */
  doSave = () => {
    // const {values} = this.props;

    let data = {
      btnFlag: '1', // 1: 一時保存ボタン
    };
    this.props.closeButton(data);
  };

  /**
   * 判定
   */
  doHantei = () => {
    this.setState({
      isHanteiResultModalShow: true,
    });
  };

  /**
   * 戻る
   */
  doBack = () => {
    this.props.reset();
    let data = {
      btnFlag: '2',
    };
    this.props.closeButton(data);
  };

  /**
   * 屋外調査 不適合理由選択戻る
   */
  handleOkgFutekigoRiyuReturn = () => {
    this.setState({
      isOkugaiFutekiRiyuModalShow: false,
    });
  };

  /**
   * 屋外調査 不適合理由選択確定
   */
  handleOkgFutekigoConfirm = () => {
    this.setState({
      isOkugaiFutekiRiyuModalShow: false,
    });
  };

  /**
   * 屋内調査 不適合理由選択戻る
   */
  handleOknFutekigoReturn = () => {
    this.setState({
      isOkunaiFutekiRiyuModalShow: false,
    });
  };

  /**
   * 屋内調査 不適合理由選択確定
   */
  handleOknFutekigoConfirm = () => {
    this.setState({
      isOkunaiFutekiRiyuModalShow: false,
    });
  };

  /**
   * 判定結果戻る
   */
  handleHanteiReturn = () => {
    this.setState({
      isHanteiResultModalShow: false,
    });
  };

  /**
   * 判定結果確定
   */
  handleHanteiConfirm = () => {
    this.setState({
      isHanteiResultModalShow: false,
    });
  };

  /**
   * 分岐回路戻る
   */
  handleBunkiKairoReturn = () => {
    this.setState({
      isBunkiKairoModalShow: false,
    });
  };

  /**
   * 分岐回路確定
   */
  handleBunkiKairoConfirm = () => {
    this.setState({
      isBunkiKairoModalShow: false,
    });
  };

  // /**
  //  * 必須チェック
  //  * @param {*} required
  //  * @param {*} header
  //  * @param {*} value
  //  * @param {*} rowIndex
  //  * @return {*} 結果
  //  */
  // _requiredCheck = (required, header, value, rowIndex=' ') => {
  //   if (required) {
  //     return requiredCheck(header, value, rowIndex);
  //   }
  //   return {};
  // };

  // /**
  //  * 桁数チェック
  //  * @param {*} maxLength
  //  * @param {*} header
  //  * @param {*} value
  //  * @param {*} rowIndex
  //  * @return {*} 結果
  //  */
  // _lengthCheck = (maxLength, header, value, rowIndex) => {
  //   if (maxLength && maxLength > 0) {
  //     return lengthCheck(header, value, maxLength, rowIndex);
  //   }
  //   return {};
  // };

  /**
   * 訪問状態の要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  _renderHomonStatusInfo = () => {
    const isDisabled = this.state.isDisabled;
    const homonStatus = [
      {cd: '1', name: '在宅'},
      {cd: '2', name: '不在'},
      {cd: '3', name: '拒否'},
      {cd: '4', name: '目視点検'},
    ];
    let homonStatusList = this.getKbnList(homonStatus);

    const tyousaZisiStatus = [
      {cd: '1', name: '連絡とれない'},
      {cd: '2', name: '連絡とれたが拒否'},
    ];
    let tsZisiStatusList = this.getKbnList(tyousaZisiStatus);

    return (
      <PaperPart>
        <Grid container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={4} >
            <Typography variant="h6" gutterBottom sx={{fontWeight: 'bold', marginBottom: '10px'}}>訪問状態</Typography>
          </Grid>
          {/* <Grid item xs={4}>
            <Typography variant="h7" gutterBottom sx={{fontWeight: 'bold', marginBottom: '10px'}}>位置取得済</Typography>
          </Grid> */}
        </Grid>
        <Grid container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}>
          <Grid key="keyHomonDate" item xs={3}>
            <Field
              id="homonDate"
              name="homonDate"
              component={renderTextField}
              className='fields'
              fullWidth
              label="訪問日"
              type="date"
              required={true}
              InputLabelProps={{
                shrink: true,
              }}
              validate={[
                validateRule.required,
                validateRule.date,
              ]}
              InputProps={{
                readOnly: isDisabled,
              }}
            />
          </Grid>
          <Grid key="tsTkUserId" item xs={12} sm={3}>
            <Field
              id="tsTkUserId"
              name="tsTkUserId"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="担当者"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={'TB0001'}>{'田中　一郎'}</MenuItem>
              <MenuItem value={'TB0002'}>{'田中　二郎'}</MenuItem>

            </Field>
          </Grid>
          <Grid key="keyHomonStatus" item sm={3}>
            <Field
              id="homonStatus"
              name="homonStatus"
              component={renderSelect}
              className='fields'
              fullWidth
              label="訪問状態"
              required={true}
              onChange={this._handleHomonStatusChange}
              validate={[
                validateRule.required,
              ]}
            >
              {homonStatusList}
            </Field>
          </Grid>

        </Grid>
        <Grid container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}>

          <Grid item sm={3} sx={{marginTop: '-10px', marginBottom: '10px', marginLeft: '10px'}}>
            <Field
              className='checkbox'
              id='jisiZumi'
              name='jisiZumi'
              component={renderCheckbox}
              label='全使撤'
              checked="true"
              validate={[]}
              disabled={true}
            />
          </Grid>
          <Grid item sm={3} sx={{marginTop: '-10px', marginBottom: '10px'}}>
            <Field
              className='checkbox'
              id='unJisi'
              name='unJisi'
              component={renderCheckbox}
              label='特定不能'
              checked="true"
              validate={[]}
              disabled={true}
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={3}>
            <Field
              id="tsZJisiStatus"
              name="tsZisiStatus"
              component={renderSelect}
              className='fields'
              fullWidth
              label="連絡状況"
              required={false}
              // validate={[
              //   validateRule.required,
              // ]}
            >
              {tsZisiStatusList}
            </Field>
          </Grid>
          <Grid key="noteDate" item xs={3}>
            <Field
              id="noteDate"
              name="noteDate"
              component={renderTextField}
              className='fields'
              fullWidth
              label="通知日"
              type="date"
              required={false}
              InputLabelProps={{
                shrink: true,
              }}
              validate={[
                validateRule.date,
              ]}
              InputProps={{
                readOnly: isDisabled,
              }}
            />
          </Grid>
          <Grid key="lastDate" item xs={3}>
            <Field
              id="lastDate"
              name="lastDate"
              component={renderTextField}
              className='fields'
              fullWidth
              label="次回予定日"
              type="date"
              required={false}
              InputLabelProps={{
                shrink: true,
              }}
              validate={[
                validateRule.date,
              ]}
              InputProps={{
                readOnly: isDisabled,
              }}
            />
          </Grid>
          <Grid key="surveyYear" item xs={3}>
            <Field
              id="surveyYear"
              name="surveyYear"
              component={renderSelect}
              className="fields"
              label="AM／PM"
              fullWidth
              type="text"
              required={false}
              validate={[
              ]}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'AM'}</MenuItem>
              <MenuItem value={2}>{'PM'}</MenuItem>
            </Field>
          </Grid>
        </Grid>
      </PaperPart>
    );
  };

  /**
   * 測定・計器の要素生成
   * @param {*} i
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  _renderKeikiInfo = (i) => {
    const isDisabled = this.state.isDisabled;

    return (
      <>
        <div style={{marginTop: '8px'}}></div>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item sm={3}>
            <Field
              id={'keikiNo'+i}
              name={'keikiNo'+i}
              component={renderTextField}
              className="fields"
              label='計器ID'
              fullWidth
              type="text"
              InputProps={{
                readOnly: isDisabled,
              }}
            />
          </Grid>
          <Grid item sm={3}>
            <Field
              className='checkbox'
              id={'keikiNasi'+i}
              name={'keikiNasi'+i}
              component={renderCheckbox}
              label='計器無'
              disabled={isDisabled}
              sx={{marginLeft: '10px'}}
            />
          </Grid>
          <Grid item sm={3}>
            <Field className='checkbox'
              id={'skuteiFuno'+i}
              name={'skuteiFuno'+i}
              component={renderCheckbox}
              label='測定不能'
              disabled={isDisabled}
            />
          </Grid>
        </Grid>

        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item sm={3}>
            <Field
              id={'zetuenTeikoti'+i}
              name={'zetuenTeikoti'+i}
              component={renderTextField}
              className="fields"
              label="絶縁抵抗値"
              fullWidth
              type="text"
              InputProps={{
                endAdornment: <InputAdornment position="end">MΩ</InputAdornment>,
                readOnly: isDisabled,
              }}
            />
          </Grid>
          <Grid item sm={3}>
            <Field
              id={'ioIor'+i}
              name={'ioIor'+i}
              component={renderTextField}
              className="fields"
              label="I0(I0r)"
              fullWidth
              type="text"
              InputProps={{
                endAdornment: <InputAdornment position="end">mA</InputAdornment>,
                readOnly: isDisabled,
              }}
            />
          </Grid>

          <Grid item sm={3}>
            <Field
              id={'io'+i}
              name={'io'+i}
              component={renderTextField}
              className="fields"
              label="I0"
              fullWidth
              type="text"
              InputProps={{
                endAdornment: <InputAdornment position="end">mA</InputAdornment>,
                readOnly: isDisabled,
              }}
            />
          </Grid>
        </Grid>

        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item sm={3}>
            <Field
              id={'sijisu'+i}
              name={'sijisu'+i}
              component={renderTextField}
              className="fields"
              label="指示数"
              fullWidth
              type="text"
              InputProps={{
                readOnly: isDisabled,
              }}
            />
          </Grid>
          <Grid item sm={4}>
            <Field
              className='checkbox'
              id={'sujisuKakuninFunou'+i}
              name={'sujisuKakuninFunou'+i}
              component={renderCheckbox}
              label='指示数確認不能'
              sx={{marginLeft: '10px'}}
              disabled={isDisabled}
            />
          </Grid>
        </Grid>

        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
        </Grid>
      </>
    );
  };

  /**
   * 測定・計器の要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  _renderStAndKkInfo = () => {
    // const isDisabled = this.state.isDisabled;
    const keikiRadioVal = this.state.keikiRadioVal;
    let keikiRadioItems = [
      {cd: '1', cdName: '7890'},
      {cd: '2', cdName: '7891'},
      {cd: '3', cdName: '7892'},
      {cd: '4', cdName: '7893'},
    ];

    return (
      <PaperPart>
        <Grid container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={4} >
            <Typography variant="h6" gutterBottom sx={{fontWeight: 'bold', marginBottom: '10px'}}>測定・計器</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="h7" gutterBottom sx={{fontWeight: 'bold', marginBottom: '10px'}}>位置情報取得済</Typography>
          </Grid>
        </Grid>
        {/* <Grid item xs={12}>
          <Typography variant="h6" gutterBottom sx={{fontWeight: 'bold'}}>測定・計器</Typography>
        </Grid> */}
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Typography variant="subtitle1" gutterBottom style={{margin: '8px 0px 0px 20px'}}>計器</Typography>
          <Grid item xs={9}>
            <Field
              key='keyKeikiRadio'
              id='keikiRadio'
              name='keikiRadio'
              component={renderRadioGroup}
              onChange={this._handleKeikiRadioChange}
              defaultValue={'1'}
              row
            >
              {this.getRadioItems(keikiRadioItems, 'keikiRadio')}
            </Field>
          </Grid>
          <Grid item sm={1}>
            <PositiveButton
              id={'btnBranchCircuit'}
              name={'btnBranchCircuit'}
              variant="contained"
              disabled={false}
              size="middle"
              onClick={(this.handleBunkiKairo)}
            >
              <span>分岐回路</span>
            </PositiveButton>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          {keikiRadioVal && this._renderKeikiInfo(keikiRadioVal)}
        </Grid>
        <Grid item xs={12}>
          {this.state.isBunkiKairoModalShow &&
              this._renderBunkiKairoModal()}
        </Grid>
      </PaperPart>
    );
  };

  /**
   * 計器ラジオボタンのイベント
   * @param {*} event
   */
  _handleKeikiRadioChange = (event) => {
    this.setState({
      keikiRadioVal: event.target.value,
    });
  };

  /**
   * 分岐回路
   */
  handleBunkiKairo = () => {
    this.setState({
      isBunkiKairoModalShow: true,
    });
  };

  /**
   * 一覧描画
   * @return {*}
   */
  renderTableBunki = () => {
    const isDisabled = this.state.isDisabled;
    const props = {
      rowHeaderType: 'none',
      filterOn: false,
      exceptFilters: [],
      allowSorting: 'None',
      isReadOnly: isDisabled,
      validateEdits: false,
      trackChanges: true,
      screenId: 'BunkiKairo',
      maxRowSize: 10,
      // getError: this.getError,
    };
    const component = createComponents(this._gridItems, isDisabled);
    return (
      <CustomFlexGrid ref={this.gridRefBunki} {...props}>
        {component}
      </CustomFlexGrid>
    );
  };

  /**
   * 分岐回路測定順序の要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  _renderBunkiKairoTable = () => {
    const {classes} = this.props;
    const element = [];
    element.push(
        <TableRow key={'tableHead'}>
          <TableCell className={classes.tableHeader}>{'No'}</TableCell>
          <TableCell className={classes.tableHeader}>{'絶縁抵抗値[MΩ]'}</TableCell>
          <TableCell className={classes.tableHeader}>{'I0(I0r)[mA]'}</TableCell>
          <TableCell className={classes.tableHeader}>{'No'}</TableCell>
          <TableCell className={classes.tableHeader}>{'絶縁抵抗値[MΩ]'}</TableCell>
          <TableCell className={classes.tableHeader}>{'I0(I0r)[mA]'}</TableCell>
        </TableRow>,
    );
    for (let i = 0; i < 5; i++) {
      element.push(
          <TableRow key={'tableRow'+ i}>
            <TableCell className={classes.tableData} style={{textAlign: 'center'}}>{1+i}</TableCell>
            <TableCell className={classes.tableData}>
              <Field className={classes.fields}
                id={'bkZetuenTeikoti'+i}
                name={'bkZetuenTeikoti'+i}
                component={renderTextField}
                type="text"
              />
            </TableCell>
            <TableCell className={classes.tableData}>
              <Field className={classes.fields}
                id={'bkIoVal'+i}
                name={'bkIoVal'+i}
                component={renderTextField}
                type="text"
              />
            </TableCell>
            <TableCell className={classes.tableData} style={{textAlign: 'center'}}>{6+i}</TableCell>
            <TableCell className={classes.tableData}>
              <Field className={classes.fields}
                id={'bkZetuenTeikoti'+(6+i)}
                name={'bkZetuenTeikoti'+(6+i)}
                component={renderTextField}
                type="text"
              />
            </TableCell>
            <TableCell className={classes.tableData}>
              <Field className={classes.fields}
                id={'bkIoVal'+(6+i)}
                name={'bkIoVal'+(6+i)}
                component={renderTextField}
                type="text"
              />
            </TableCell>
          </TableRow>,
      );
    }

    return (
      <Table className={classes.table}>
        <TableBody>
          {element}
        </TableBody>
      </Table>
    );
  };

  /**
   * 分岐回路の要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  _renderBunkiKairoModal = () => {
    const {classes,
      // openState,
      // handleClose, handleExec
    } = this.props;

    const bunnkiOrder = [
      {cd: '1', name: '右上'},
      {cd: '2', name: '左上'},
      {cd: '3', name: '左下'},
      {cd: '4', name: '右下'},
    ];
    const bunkiKairoOrderList = this.getKbnList(bunnkiOrder);

    return (
      <Modal
        // open={openState}
        open={this.state.isBunkiKairoModalShow}
      >
        <PaperPart className={classes.paper}>
          <Typography variant='h6' sx={{fontWeight: 'bold'}}>分岐回路測定</Typography>
          <div style={{marginBottom: '20px'}} />
          <Grid key="keyBunkiKairoSokutei" item xs={4}>
            <Field
              id="bunkiKairoOrder"
              name="bunkiKairoOrder"
              component={renderSelect}
              className='fields'
              fullWidth
              label="分岐回路測定順序"
              type="text"
              InputProps={{
                readOnly: false,
              }}
            >
              {bunkiKairoOrderList}
            </Field>
          </Grid>

          <Grid key="keyBunkiKairoTable" item xs={12}>
            {/* {this.renderTableBunki()} */}
            {this._renderBunkiKairoTable()}
          </Grid>
          <div style={{marginBottom: '20px'}} />
          <Grid
            container
            justifyContent="center"
            alignItems="flex-end"
            spacing={1}
          >
            <Grid key="keyBunkiKairoModalConfirm" item >
              <PositiveButton
                id="btnBunkiKairoConfirm"
                variant="contained"
                startIcon={<SaveIcon />}
                size="middium"
                // disabled={isDisabled}
                onClick={this.handleBunkiKairoConfirm}
              >
                <span>確定</span>
              </PositiveButton>
            </Grid>
            <Grid key="keyBunkiKairoModalReturn" item >
              <NegativeButton
                id="btnBunkiKairoReturn"
                variant="contained"
                startIcon={<KeyboardReturnIcon />}
                size="middium"
                onClick={this.handleBunkiKairoReturn}
              >
                <span>閉じる</span>
              </NegativeButton>
            </Grid>
          </Grid>
        </PaperPart>
      </Modal>
    );
  };
  /**
   * 全使撤／特定不能の要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  // _renderZensiInfo = () => {
  //   const isDisabled = this.state.isDisabled;
  //   return (
  //     <PaperPart>
  //       <Grid item xs={12}>
  //         <Typography variant="h6" gutterBottom sx={{fontWeight: 'bold'}}>全使撤／特定不能</Typography>
  //       </Grid>
  //       <Grid
  //         container
  //         justifyContent="flex-start"
  //         alignItems="center"
  //         spacing={1}
  //       >
  //         <Grid item sm={2}>
  //           <Field
  //             className='checkbox'
  //             id='jisiZumi'
  //             name='jisiZumi'
  //             component={renderCheckbox}
  //             label='全使撤'
  //             validate={[]}
  //             disabled={isDisabled}
  //           />
  //         </Grid>
  //         <Grid item sm={3}>
  //           <Field
  //             className='checkbox'
  //             id='unJisi'
  //             name='unJisi'
  //             component={renderCheckbox}
  //             label='特定不能'
  //             validate={[]}
  //             disabled={isDisabled}
  //           />
  //         </Grid>
  //       </Grid>
  //     </PaperPart>
  //   );
  // };

  /**
   * 屋外調査の要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  _renderOkugaiInfo = () => {
    const isDisabled = this.state.isDisabled;
    return (
      <PaperPart>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom sx={{fontWeight: 'bold'}}>屋外調査</Typography>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Typography variant="subtitle1" gutterBottom style={{margin: '8px 0px 0px 20px'}}>調査結果</Typography>
          <Grid item sm={6}>
            <Field
              key='okugaiTsResult'
              id='okugaiTsResult'
              name='okugaiTsResult'
              component={renderRadioGroup}
              // onChange={this._handleOkugaiTsChangeRadio}
              row
            >
              <FormControlLabel
                key='okugaiTsResult1'
                value='1'
                control={<Radio />}
                label={'良'}
                disabled={isDisabled}
              />
              <FormControlLabel
                key='okugaiTsResult2'
                value='2'
                control={<Radio />}
                label={'否'}
                disabled={isDisabled}
              />
              <FormControlLabel
                key='okugaiTsResult3'
                value='3'
                control={<Radio />}
                label={'不能'}
                disabled={isDisabled}
              />
              <FormControlLabel
                key='okugaiTsResult4'
                value='4'
                control={<Radio />}
                label={'未'}
                disabled={isDisabled}
              />
            </Field>
          </Grid>
          {/* {this.state.isOkugaiTsFunouSelect &&
          <Grid item sm={3}>
            <Field
              id='ubableOkugaiTsRiyu'
              name='ubableOkugaiTsRiyu'
              component={renderSelect}
              className='fields'
              label='調査不能理由'
              fullWidth
              disabled={isDisabled}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'定期不能理由マスタ 区分２'}</MenuItem>
            </Field>
          </Grid>
          }
          {this.state.isOkugaiTsHiSelect &&
          this._renderOkugaiRiyuSelectModal()} */}
        </Grid>

        {/* <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item sm={3}>
            <Field
              id='ubableOkugaiTsRiyu'
              name='ubableOkugaiTsRiyu'
              component={renderSelect}
              className='fields'
              label='目視項目'
              fullWidth
              disabled={isDisabled}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'定期点検共通マスタ目視区分ＣＤ'}</MenuItem>
            </Field>
          </Grid>
        </Grid> */}

        {/* <Grid item sm={3}>
          <Field
            id='panfletHaifusu'
            name='panfletHaifusu'
            component={renderTextField}
            className="fields"
            label="パンフレット配布数"
            fullWidth
            type="text"
            InputProps={{
              readOnly: isDisabled,
            }}
          />
        </Grid> */}

        {/* <Grid item xs={12} style={{margin: '0px 0px 0px 0px'}}>
          <Grid item sm={3}>
            <Field
              id='OkugaiNoticeNo'
              name='OkugaiNoticeNo'
              component={renderTextField}
              className="fields"
              label="お知らせNo"
              fullWidth
              type="text"
              InputProps={{
                readOnly: isDisabled,
              }}
            />
          </Grid>
        </Grid> */}

      </PaperPart>
    );
  };

  /**
   * 屋内調査の要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  _renderOkunaiInfo = () => {
    const isDisabled = this.state.isDisabled;
    return (
      <PaperPart>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom sx={{fontWeight: 'bold'}}>屋内調査</Typography>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Typography variant="subtitle1" gutterBottom style={{margin: '8px 0px 0px 20px'}}>調査結果</Typography>
          <Grid item sm={6}>
            <Field
              key='okunaiTsResult'
              id='okunaiTsResult'
              name='okunaiTsResult'
              component={renderRadioGroup}
              // onChange={this._handleOkunaiTsChangeRadio}
              row
            >
              <FormControlLabel
                key='okunaiTsResult1'
                value='1'
                control={<Radio />}
                label={'良'}
                disabled={isDisabled}
              />
              <FormControlLabel
                key='okunaiTsResult2'
                value='2'
                control={<Radio />}
                label={'否'}
                disabled={isDisabled}
              />
              <FormControlLabel
                key='okunaiTsResult3'
                value='3'
                control={<Radio />}
                label={'不能'}
                disabled={isDisabled}
              />
              <FormControlLabel
                key='okunaiTsResult4'
                value='4'
                control={<Radio />}
                label={'未'}
                disabled={isDisabled}
              />
            </Field>
          </Grid>
          {/* {this.state.isOkunaiTsFunouSelect &&
          <Grid item sm={3}>
            <Field
              id='ubableOkunaiTsRiyu'
              name='ubableOkunaiTsRiyu'
              component={renderSelect}
              className='fields'
              label='調査不能理由'
              fullWidth
              disabled={isDisabled}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'定期不能理由マスタ 区分３'}</MenuItem>
            </Field>
          </Grid>
          }
          {this.state.isOkunaiTsHiSelect &&
          this._renderOkunaiRiyuSelectModal()} */}
        </Grid>

        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Typography variant="subtitle1" gutterBottom style={{margin: '8px 0px 0px 20px'}}>単３開閉器</Typography>
          <Grid item sm={5}>
            <Field
              key='hasSwitch'
              id='hasSwitch'
              name='hasSwitch'
              // defaultValue={'1'}
              component={renderRadioGroup}
              onChange={this._handleSwitchChange}
              row
            >
              <FormControlLabel
                key='hasSwitchAri'
                value='1'
                control={<Radio />}
                label={'有'}
                disabled={isDisabled}
              />
              <FormControlLabel
                key='hasSwitchNasi'
                value='2'
                control={<Radio />}
                label={'無'}
                disabled={isDisabled}
              />
            </Field>
          </Grid>
        </Grid>

        {this.state.isSwitchNasi &&
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          style={{margin: '0px 0px 0px -15px'}}
        >
          <Grid item sm={3}>
            <Field
              id='tkOk'
              name='tkOk'
              component={renderTextField}
              className="fields"
              label="点検良好"
              fullWidth
              // MaxLength={3}
              type="number"
              InputProps={{
                readOnly: isDisabled,
              }}
            />
          </Grid>
          <Grid item sm={3}>
            <Field
              id='raiseStop'
              name='raiseStop'
              component={renderTextField}
              className="fields"
              label="増し締め"
              fullWidth
              // MaxLength={3}
              type="number"
              InputProps={{
                readOnly: isDisabled,
              }}
            />
          </Grid>
          <Grid item sm={3}>
            <Field
              id='tsFunou'
              name='tsFunou'
              component={renderTextField}
              className="fields"
              label="点検不能"
              fullWidth
              // MaxLength={3}
              type="number"
              InputProps={{
                readOnly: isDisabled,
              }}
            />
          </Grid>
          {/* <Grid item sm={3}>
            <Field
              id='ubableOkunaiTkRiyu'
              name='ubableOkunaiTkRiyu'
              component={renderSelect}
              className='fields'
              label='点検不能理由'
              fullWidth
              disabled={isDisabled}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'定期不能理由マスタ 区分４'}</MenuItem>
            </Field>
          </Grid> */}
        </Grid>
        }
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item sm={1}>
            <Typography variant="subtitle1" gutterBottom style={{margin: '0px 0px 0px 10px'}}>問診</Typography>
          </Grid>
          <Grid item sm={2}>
            <Field
              className='checkbox'
              id='jisiZumi'
              name='jisiZumi'
              component={renderCheckbox}
              label='実施済'
              validate={[]}
              disabled={isDisabled}
            />
          </Grid>
          <Grid item sm={3}>
            <Field
              className='checkbox'
              id='unJisi'
              name='unJisi'
              component={renderCheckbox}
              label='在宅未実施'
              validate={[]}
              disabled={isDisabled}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} style={{margin: '0px 0px 0px 0px'}}>
          <Grid item sm={4}>
            <Field
              id='OkunaiNoticeNo'
              name='OkunaiNoticeNo'
              component={renderTextField}
              className="fields"
              label="お知らせNo"
              fullWidth
              type="text"
              InputProps={{
                readOnly: isDisabled,
              }}
            />
          </Grid>
        </Grid>

      </PaperPart>
    );
  };

  /**
   * 調査メモの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  _renderTsMemoInfo = () => {
    const isDisabled = this.state.isDisabled;
    return (
      <PaperPart>
        <Typography variant="h6" gutterBottom sx={{fontWeight: 'bold'}}>調査メモ</Typography>
        <Field
          id="tsMemo"
          name="tsMemo"
          component={renderTextField}
          className='fields'
          fullWidth
          label="メモ"
          type="text"
          multiline={true}
          rows={3}
          InputProps={{
            readOnly: isDisabled,
          }}
        />
      </PaperPart>
    );
  };

  /**
   * 調査業種の要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  _renderTsGyosyuInfo = () => {
    const isDisabled = this.state.isDisabled;
    const chousaIndustry = [
      {cd: '02', name: '寝老人'},
      {cd: '03', name: 'プール'},
      {cd: '04', name: '浴場'},
      {cd: '05', name: '学校等'},
      {cd: '06', name: '病院等'},
      {cd: '07', name: '老人福祉'},
      {cd: '08', name: '重要文化財'},
      {cd: '09', name: '学校でかつプール施設'},
    ];
    let tsGyosyuList = this.getKbnList(chousaIndustry);

    const hijikaCategory = [
      {cd: '0', name: '非自家用'},
      {cd: '3', name: '低圧自家用'},
      {cd: 'A', name: 'ＪＲ調査'},
      {cd: 'B', name: 'ＪＲ調査拒否'},
    ];
    let tsKanriKbnList = this.getKbnList(hijikaCategory);

    return (
      <PaperPart>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom sx={{fontWeight: 'bold'}}>調査業種</Typography>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={4}>
            <Field
              id="beforeHenkoTsGyosyu"
              name="beforeHenkoTsGyosyu"
              component={renderSelect}
              className='fields'
              fullWidth
              label="変更前調査業種"
              disabled={isDisabled}
            >
              {tsGyosyuList}
            </Field>
          </Grid>
          <Grid item xs={4}>
            <Field
              id="afterHenkoTsGyosyu"
              name="afterHenkoTsGyosyu"
              component={renderSelect}
              className='fields'
              fullWidth
              label="変更後調査業種"
              disabled={isDisabled}
            >
              {tsGyosyuList}
            </Field>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={4}>
            <Field
              id="beforeHenkoTsKanriKbn"
              name="beforeHenkoTsKanriKbn"
              component={renderSelect}
              className='fields'
              fullWidth
              label="変更前調査管理区分"
              disabled={isDisabled}
            >
              {tsKanriKbnList}
            </Field>
          </Grid>
          <Grid item xs={4}>
            <Field
              id="afterHenkoTsKanriKbn"
              name="afterHenkoTsKanriKbn"
              component={renderSelect}
              className='fields'
              fullWidth
              label="変更後調査管理区分"
              disabled={isDisabled}
            >
              {tsKanriKbnList}
            </Field>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={12}>
            <Field
              id="tsGyosyuMemo"
              name="tsGyosyuMemo"
              component={renderTextField}
              className='fields'
              fullWidth
              label="備考"
              type="text"
              multiline={true}
              rows={3}
              InputProps={{
                readOnly: isDisabled,
              }}
            />
          </Grid>
        </Grid>

      </PaperPart>
    );
  };

  /**
   * 翌年度再調査理由の要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  _renderYokunendoTsRiyuInfo = () => {
    const isDisabled = this.state.isDisabled;
    const isYknDisabled = this.state.isYknDisabled || isDisabled;
    const chousaReason = [
      {cd: '12', name: '漏えい電流が1mA超過で未調査'},
      {cd: '13', name: '漏えい電流の測定不能'},
      {cd: '99', name: '調査理由の取消'},
    ];
    let tsRiyuList = this.getKbnList(chousaReason);

    return (
      <PaperPart>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom sx={{fontWeight: 'bold'}}>翌年度再調査理由</Typography>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          {/* <Grid item xs={6}>
            <Field
              id='chkSokuteFunou'
              name='chkSokuteFunou'
              component={renderCheckbox}
              className='checkbox'
              label='漏洩電流測定不能'
              onChange={this._handleSokuteFunouChange}
              disabled={isDisabled}
              sx={{marginLeft: '10px'}}
            />
          </Grid> */}
          {/* <Grid item xs={6}></Grid> */}
          <Grid item xs={6}>
            <Field
              id="yokunendoTsRiyu"
              name="yokunendoTsRiyu"
              component={renderSelect}
              className='fields'
              fullWidth
              label="翌年度再調査理由"
              disabled={isYknDisabled}
            >
              {tsRiyuList}
            </Field>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={12}>
            <Field
              id="yokunendoTsRiyuMemo"
              name="yokunendoTsRiyuMemo"
              component={renderTextField}
              className='fields'
              fullWidth
              label="備考"
              type="text"
              multiline={true}
              rows={3}
              InputProps={{
                readOnly: isDisabled,
              }}
            />
          </Grid>
        </Grid>

      </PaperPart>
    );
  };

  /**
   * 屋外調査の調査結果が否の場合の要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  _renderOkugaiRiyuSelectModal = () => {
    const {classes,
      // openState,
      // handleClose, handleExec
    } = this.props;

    let chkElements = [];

    let chkItems = ['配線その他', 'コード配線', '開閉器等', '配線用器具', '接地関係', '漏電遮断器', 'その他'];
    for (let i=0; i<chkItems.length; i++) {
      chkElements.push(
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >
            <Grid item sm={4}>
              <Typography variant="subtitle1" gutterBottom style={{margin: '8px 0px 0px 10px'}}>{chkItems[i]}</Typography>
            </Grid>
            <Grid item sm={4}>
              <Field className='checkbox'
                id={'chkOkgHoanueJyuyo'+i}
                name={'chkOkgHoanueJyuyo'+i}
                component={renderCheckbox}
                label='保安上重要'
                validate={[]}
                // disabled={isDisabled}
              />
            </Grid>
            <Grid item sm={4}>
              <Field className='checkbox'
                id={'chkOkgFuryo'+i}
                name={'chkOkgFuryo'+i}
                component={renderCheckbox}
                label='不良'
                validate={[]}
                // disabled={isDisabled}
              />
            </Grid>
          </Grid>,
      );
    }

    return (
      <Modal
        // open={openState}
        open={this.state.isOkugaiFutekiRiyuModalShow}
      >
        <PaperPart className={classes.paper}>
          <Typography variant='h6' sx={{fontWeight: 'bold'}}>不適合理由選択</Typography>
          <div style={{marginBottom: '20px'}} />
          {chkElements}
          <div style={{marginBottom: '20px'}} />
          <Grid
            container
            justifyContent="center"
            alignItems="flex-end"
            spacing={1}
          >
            <Grid key="keyOkgModalReturn" item >
              <NegativeButton
                id="btnOkgRiyuReturn"
                variant="contained"
                startIcon={<KeyboardReturnIcon />}
                size="middium"
                onClick={this.handleOkgFutekigoRiyuReturn}
              >
                <span>戻る</span>
              </NegativeButton>
            </Grid>
            <Grid key="keyOkgModalConfirm" item >
              <PositiveButton
                id="btnOkgRiyuConfirm"
                variant="contained"
                startIcon={<SaveIcon />}
                size="middium"
                // disabled={isDisabled}
                onClick={this.handleOkgFutekigoConfirm}
              >
                <span>確定</span>
              </PositiveButton>
            </Grid>
          </Grid>
        </PaperPart>
      </Modal>
    );
  };

  /**
   * 屋内調査の調査結果が否の場合の要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  _renderOkunaiRiyuSelectModal = () => {
    const {classes,
      // openState,
      // handleClose, handleExec
    } = this.props;

    let chkElements = [];

    let chkItems = ['配線屋内', 'コード配線', '開閉器等', '配線用器具', '接地関係', '漏電遮断器', 'その他'];
    for (let i=0; i<chkItems.length; i++) {
      chkElements.push(
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >
            <Grid item sm={4}>
              <Typography variant="subtitle1" gutterBottom style={{margin: '8px 0px 0px 10px'}}>{chkItems[i]}</Typography>
            </Grid>
            <Grid item sm={4}>
              <Field className='checkbox'
                id={'chkOknHoanueJyuyo'+i}
                name={'chkOknHoanueJyuyo'+i}
                component={renderCheckbox}
                label='保安上重要'
                validate={[]}
                // disabled={isDisabled}
              />
            </Grid>
            <Grid item sm={4}>
              <Field className='checkbox'
                id={'chkOknFuryo'+i}
                name={'chkOknFuryo'+i}
                component={renderCheckbox}
                label='不良'
                validate={[]}
                // disabled={isDisabled}
              />
            </Grid>
          </Grid>,
      );
    }

    return (
      <Modal
        // open={openState}
        open={this.state.isOkunaiFutekiRiyuModalShow}
      >
        <PaperPart className={classes.paper}>
          <Typography variant='h6' sx={{fontWeight: 'bold'}}>不適合理由選択</Typography>
          <div style={{marginBottom: '20px'}} />
          {chkElements}
          <div style={{marginBottom: '20px'}} />
          <Grid
            container
            justifyContent="center"
            alignItems="flex-end"
            spacing={1}
          >
            <Grid key="keyOknModalReturn" item >
              <NegativeButton
                id="btnOknRiyuReturn"
                variant="contained"
                startIcon={<KeyboardReturnIcon />}
                size="middium"
                onClick={this.handleOknFutekigoReturn}
              >
                <span>戻る</span>
              </NegativeButton>
            </Grid>
            <Grid key="keyOknModalConfirm" item >
              <PositiveButton
                id="btnOknRiyuConfirm"
                variant="contained"
                startIcon={<SaveIcon />}
                size="middium"
                // disabled={isDisabled}
                onClick={this.handleOknFutekigoConfirm}
              >
                <span>確定</span>
              </PositiveButton>
            </Grid>
          </Grid>
        </PaperPart>
      </Modal>
    );
  };

  /**
   * 判定結果の要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  _renderHanteiResultModal = () => {
    const {classes,
      // openState,
      // handleClose, handleExec
    } = this.props;


    return (
      <Modal
        // open={openState}
        open={this.state.isHanteiResultModalShow}
        style={{
          maxWidth: 1500,
          marginLeft: 'auto',
          marginRight: 'auto',
          overflow: 'visible',
        }}
      >
        <PaperPart className={classes.paper}>
          <Typography variant='h6' sx={{fontWeight: 'bold'}}>判定結果</Typography>
          <div style={{marginBottom: '20px'}} />
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >
            <Grid key="keyCustomerName" item xs={6}>
              <Field
                id="customerName"
                name="customerName"
                component={renderTextField}
                className='fields'
                fullWidth
                label="お客さま名"
                type="text"
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid key="keyKeisyuSoteiCd" item xs={6}>
              <Field
                id="keisyuSoteiCd"
                name="keisyuSoteiCd"
                component={renderTextField}
                className='fields'
                fullWidth
                label="契種"
                type="text"
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>

            <Grid key="keyServicemMenu" item xs={6}>
              <Field
                id="servicemMenu"
                name="servicemMenu"
                component={renderTextField}
                className='fields'
                fullWidth
                label="サービスメニュー"
                type="text"
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid key="keyDummy1" item xs={6}></Grid>

            <Grid key="keyHanteiResult" item xs={6}>
              <Field
                id="hanteiResult"
                name="hanteiResult"
                component={renderTextField}
                className='fields'
                fullWidth
                label="判定結果"
                type="text"
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid key="keyDummy2" item xs={6}></Grid>

            <Grid key="keyOsiraseiNo" item xs={6}>
              <Field
                id="osiraseiNo"
                name="osiraseiNo"
                component={renderTextField}
                className='fields'
                fullWidth
                label="お知らせNo"
                type="text"
                InputProps={{
                  readOnly: false,
                }}
              />
            </Grid>
            <Grid key="keyDummy3" item xs={6}></Grid>

            {(this.state.isOkugaiTsHiSelect || this.state.isOkunaiTsHiSelect) &&
            <Grid key="keyFutekigoRiyu" item xs={12}>
              <Field
                id="futekigoRiyu"
                name="futekigoRiyu"
                component={renderTextField}
                className='fields'
                fullWidth
                label="不適合理由"
                type="text"
                InputProps={{
                  readOnly: true,
                }}
                multiline={true}
                // rows={3}
              />
            </Grid>
            }

            {(this.state.isOkugaiTsFunouSelect || this.state.isOkunaiTsFunouSelect) &&
            <Grid key="keyFunouRiyu" item xs={12}>
              <Field
                id="funouRiyu"
                name="funouRiyu"
                component={renderTextField}
                className='fields'
                fullWidth
                label="不能理由"
                type="text"
                InputProps={{
                  readOnly: true,
                }}
                multiline={true}
                // rows={3}
              />
            </Grid>
            }
          </Grid>
          <div style={{marginBottom: '20px'}} />
          <Grid
            container
            justifyContent="center"
            alignItems="flex-end"
            spacing={1}
          >
            <Grid key="keyOkgModalReturn" item >
              <NegativeButton
                id="btnOkgRiyuReturn"
                variant="contained"
                startIcon={<KeyboardReturnIcon />}
                size="middium"
                onClick={this.handleHanteiReturn}
              >
                <span>戻る</span>
              </NegativeButton>
            </Grid>
            <Grid key="keyOkgModalConfirm" item >
              <PositiveButton
                id="btnOkgRiyuConfirm"
                variant="contained"
                startIcon={<SaveIcon />}
                size="middium"
                // disabled={isDisabled}
                onClick={this.handleHanteiConfirm}
              >
                <span>確定</span>
              </PositiveButton>
            </Grid>
          </Grid>
        </PaperPart>
      </Modal>
    );
  };

  // /**
  //  * 訪問状態ラジオボタンのイベント
  //  * @param {*} event
  //  */
  // _handleHsChangeRadio = (event) => {
  //   const radioVal = event.target.value;
  //   let _isKeikiShow = true;
  //   let _isOkugaiTsShow = true;
  //   let _isOkunaiTsShow = true;
  //   if (radioVal === '2') {
  //     _isOkunaiTsShow = false;
  //   } else if (radioVal === '3') {
  //     _isKeikiShow = false;
  //     _isOkugaiTsShow = false;
  //     _isOkunaiTsShow = false;
  //   } else if (radioVal === '4') {
  //     _isKeikiShow = false;
  //     _isOkunaiTsShow = false;
  //   }
  //   this.setState({
  //     isKeikiShow: _isKeikiShow,
  //     isOkugaiTsShow: _isOkugaiTsShow,
  //     isOkunaiTsShow: _isOkunaiTsShow,
  //   });
  // };

  _handleSokuteFunouChange = (event, val) => {
    let _isYknDisabled = false;
    if (val === true) {
      this.props.change('yokunendoTsRiyu', '13');
      _isYknDisabled = true;
    } else {
      this.props.change('yokunendoTsRiyu', '');
    }

    this.setState({
      isYknDisabled: _isYknDisabled,
    });
  };

  /**
   * 単三開閉器ラジオボタンのイベント
   * @param {*} event
   */
  _handleSwitchChange = (event) => {
    const radioVal = event.target.value;
    let _isSwitchNasi = false;
    if (radioVal === '1') {
      _isSwitchNasi = true;
    }
    this.setState({
      isSwitchNasi: _isSwitchNasi,
    });
  };

  /**
   * 訪問状態のイベント
   * @param {*} event イベント
   * @param {*} val 値
   */
  _handleHomonStatusChange = (event, val) => {
    let _isKeikiShow = false;
    let _isOkugaiTsShow = false;
    let _isOkunaiTsShow = false;
    if (val === '1') {
      _isKeikiShow = true;
      _isOkugaiTsShow = true;
      _isOkunaiTsShow = true;
    } else if (val === '2') {
      _isKeikiShow = true;
      _isOkugaiTsShow = true;
      _isOkunaiTsShow = false;
    } else if (val === '3') {
      _isKeikiShow = false;
      _isOkugaiTsShow = false;
      _isOkunaiTsShow = false;
    } else if (val === '4') {
      _isKeikiShow = false;
      _isOkugaiTsShow = true;
      _isOkunaiTsShow = false;
    }
    this.setState({
      isKeikiShow: _isKeikiShow,
      isOkugaiTsShow: _isOkugaiTsShow,
      isOkunaiTsShow: _isOkunaiTsShow,
    });
  };

  /**
   * 屋外調査結果ラジオボタンのイベント
   * @param {*} event
   */
  _handleOkugaiTsChangeRadio = (event) => {
    const radioVal = event.target.value;
    let _isOkugaiTsHiSelect = false;
    let _isOkugaiTsFunouSelect = false;
    let _isOkugaiFutekiRiyuModalShow = false;
    if (radioVal === '2') {
      _isOkugaiTsHiSelect = true;
      _isOkugaiFutekiRiyuModalShow =true;
    } else if (radioVal === '3') {
      _isOkugaiTsFunouSelect = true;
    }
    this.setState({
      isOkugaiTsHiSelect: _isOkugaiTsHiSelect,
      isOkugaiTsFunouSelect: _isOkugaiTsFunouSelect,
      isOkugaiFutekiRiyuModalShow: _isOkugaiFutekiRiyuModalShow,
    });
  };

  /**
   * 屋内調査結果ラジオボタンのイベント
   * @param {*} event
   */
  _handleOkunaiTsChangeRadio = (event) => {
    const radioVal = event.target.value;
    let _isOkunaiTsHiSelect = false;
    let _isOkunaiTsFunouSelect = false;
    let _isOkunaiFutekiRiyuModalShow = false;
    if (radioVal === '2') {
      _isOkunaiTsHiSelect = true;
      _isOkunaiFutekiRiyuModalShow =true;
    } else if (radioVal === '3') {
      _isOkunaiTsFunouSelect = true;
    }
    this.setState({
      isOkunaiTsHiSelect: _isOkunaiTsHiSelect,
      isOkunaiTsFunouSelect: _isOkunaiTsFunouSelect,
      isOkunaiFutekiRiyuModalShow: _isOkunaiFutekiRiyuModalShow,
    });
  };

  render() {
    const {
      // classes,
      handleSubmit,
    } = this.props;

    const homonHistory = [
      {cd: 'h02', name: '第二回目'},
      {cd: 'h01', name: '第一回目'},
    ];
    let homonHistoryList = this.getKbnList(homonHistory);

    return (
      <Modal
        open={this.props.modalOpen}
        style={{
          maxWidth: 800,
          marginLeft: 'auto',
          marginRight: 'auto',
          overflow: 'visible',
        }}
        disableEnforceFocus={true}
      >
        <form noValidate autoComplete="off" style={{maxHeight: '100vh'}} >
          <PaperPart style={{maxHeight: '90vh', overflow: 'auto scroll'}}>
            <PageTitle pageTitle={'調査結果詳細'}/>
            <div style={{marginBottom: '20px'}} />
            <Grid container
              justifyContent="center"
              alignItems="flex-start"
              spacing={1}>
              <Grid key="keyTsInfoMsg" item xs={12}>
                <WarningMessageArea messages={this.state.warningMessages}/>
              </Grid>
              <Grid key="keyTsInfoHomonHis" item xs={12}>
                <Grid container
                  justifyContent="center"
                  alignItems="flex-start"
                  spacing={1}>
                  <Grid key="keyHomonHistory" item sm={4}>
                    <Field
                      id="homonHistory"
                      name="homonHistory"
                      component={renderSelect}
                      className='fields'
                      fullWidth
                      label="訪問履歴"
                    >
                      {homonHistoryList}
                    </Field>
                  </Grid>
                  <Grid key="search" item sm={4} sx={{marginTop: '-15px'}}>
                    <PositiveButton
                      id="search"
                      variant="contained"
                      startIcon={<SearchIcon />}
                      className="button_list"
                      size="middle"
                      // onClick={handleSubmit(this.doSearch)}
                    >
                      <span>参照</span>
                    </PositiveButton>
                  </Grid>
                  <Grid item sm={4}></Grid>
                </Grid>
              </Grid>
              <Grid key="keyTsInfoHomonStatus" item xs={12}>
                {this._renderHomonStatusInfo()}
              </Grid>
              {this.state.isKeikiShow &&
              <Grid key="keyTsInfoKeiki" item xs={12}>
                {/* {this._renderKeikiInfo()} */}
                {this._renderStAndKkInfo()}
              </Grid>
              }
              {this.state.isOkugaiTsShow &&
              <Grid key="keyTsInfoOkugai" item xs={12}>
                {this._renderOkugaiInfo()}
              </Grid>
              }
              {this.state.isOkunaiTsShow &&
              <Grid key="keyTsInfoOkunai" item xs={12}>
                {this._renderOkunaiInfo()}
              </Grid>
              }
              <Grid key="keyTsInfoMemo" item xs={12}>
                {this._renderTsMemoInfo()}
              </Grid>
              <Grid key="keyTsInfoGyosyu" item xs={12}>
                {this._renderTsGyosyuInfo()}
              </Grid>
              <Grid key="keyTsInfoYokunedoRiyu" item xs={12}>
                {this._renderYokunendoTsRiyuInfo()}
              </Grid>
              <Grid key="keyTsInfoFooter" item xs={12}>
                <Grid
                  container
                  justifyContent="center"
                  alignItems="flex-start"
                  spacing={1}
                >
                  <Grid key="keyTsInfoSave" item>
                    <PositiveButton
                      id="btnTsInfoSave"
                      variant="contained"
                      disabled={false}
                      startIcon={<SaveIcon />}
                      size="middle"
                      onClick={handleSubmit(this.doSave)}
                    >
                      <span>確定</span>
                    </PositiveButton>
                  </Grid>
                  {/* <Grid key="keyTsInfoHantei" item>
                    <PositiveButton
                      id="btnTsInfoHantei"
                      variant="contained"
                      disabled={false}
                      startIcon={<SaveIcon />}
                      size="middle"
                      onClick={this.doHantei}
                    >
                      <span>判定</span>
                    </PositiveButton>
                    {this.state.isHanteiResultModalShow &&
                    this._renderHanteiResultModal()}
                  </Grid> */}
                  <Grid key="keyTsInfoBack" item>
                    <NegativeButton
                      id="btnTsInfoBack"
                      variant="contained"
                      startIcon={<KeyboardReturnIcon />}
                      size="middle"
                      onClick={this.doBack}
                    >
                      <span>閉じる</span>
                    </NegativeButton>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </PaperPart>
        </form>
      </Modal>
    );
  }
};

TsInfo.propTypes={
  // classes: PropTypes.object,
  values: PropTypes.object,
  // getMessage: PropTypes.func,
  handleSubmit: PropTypes.func,
  reset: PropTypes.func,
  doShowMessage: PropTypes.func,
  change: PropTypes.func,
  doSetInitValues: PropTypes.func,
  initialValues: PropTypes.object,
  dirty: PropTypes.bool,
  // 呼び出し元設定
  supplyPointNo: PropTypes.string.isRequired,
  tsKasyo: PropTypes.string,
  modalOpen: PropTypes.bool.isRequired,
  closeButton: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    initialValues: state.common.setInitValues,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'TsInfo';

TsInfo = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(TsInfo));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(withFormatMessage(withMediaQuery()(TsInfo)))),
);
